// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: ':id/team-member-deduction-payments',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-deduction-payments" */ '@/pages/[organisation]/hr/team-member-deduction-payments/team-member-deduction-payments.vue'),
        name: 'human-resource.team-member-deduction-payments.search-team-member-deduction-payments',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.deductions.view-team-member-deduction-payments',
        },
        children: [
            {
                path: ':paymentId',
                component: () =>
                    import(/* webpackChunkName: "human-resource.team-member-deduction-payments" */ '@/pages/[organisation]/hr/team-member-deduction-payments/redo-team-member-deduction-payment.vue'),
                name: 'human-resource.team-member-deduction-payments.redo-team-member-deduction-payment',
                meta: {
                    loginRequired: true,
                    permission: 'access.human-resource.deductions.create-team-member-deduction-payment',
                },
            },
        ],
    },
];
